<template>
  <section class="custom-manage">
    <z-tabs v-model="currentTab" :tabs="tabs" @change="showTab" />
    <div class="row p-3" v-if="currentTab === 'Challenges'">
      <challenges :orgid="orgid" />
    </div>
    <div class="row p-3" v-if="currentTab === 'Library'">
      <library :orgid="orgid" />
    </div>
    <div class="row p-3" v-if="currentTab === 'On-Demand'">
      <workouts :orgid="orgid" />
    </div>
    <div class="row p-3" v-if="currentTab === 'Dashboard'">
      <dashboard />
    </div>
    <div class="row p-3" v-if="currentTab === 'Nutrition Habits'">
      <nutrition-habits />
    </div>
  </section>
</template>
<script>
import ZTabs from '@/Components/ZElements/Tabs'
import Challenges from '@/Components/UserCardio/challenges/challenges'
import Library from '@/Components/UserCardio/library/library'
import Workouts from '@/Components/UserCardio/workouts/workouts'
import Dashboard from '@/Components/UserCardio/dashboard/components'
import NutritionHabits from '@/Components/UserCardio/nutrition/habits'
export default {
  name: 'member-admin',
  components: {
    ZTabs,
    Challenges,
    Library,
    Workouts,
    Dashboard,
    NutritionHabits,
  },
  props: {
    orgid: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      currentTab: 'Challenges',
      tabs: [
        'Challenges',
        'Library',
        'On-Demand',
        'Dashboard',
        'Nutrition Habits',
      ],
    }
  },
  methods: {
    showTab(value) {
      this.currentTab = value
    },
  },
}
</script>
<style scoped>
</style>